import { FC } from 'react';
import ContentLoader from 'react-content-loader';

const ListSkeleton: FC = () => {
  return (
    <ContentLoader
      speed={1}
      width="100%"
      height={432}
      backgroundColor="#f3f3f3"
      foregroundColor="#d9d9d9"
      style={{ width: '100%' }}
    >
      <rect x="0" y="14" rx="12" ry="12" width="100%" height="58" />
      <rect x="0" y="86" rx="12" ry="12" width="100%" height="58" />
      <rect x="0" y="158" rx="12" ry="12" width="100%" height="58" />
      <rect x="0" y="230" rx="12" ry="12" width="100%" height="58" />
      <rect x="0" y="302" rx="12" ry="12" width="100%" height="58" />
    </ContentLoader>
  );
};

export default ListSkeleton;
